import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
import { Observable } from 'rxjs';
import { NeoTrazabilidadAuditoriaDTO } from '../Model/neoTrazabilidadAuditoriaDTO';

@Injectable({
    providedIn: 'root'
})
export class TrazabilidadAuditoriaService {

    private readonly url: string = environment.apiLocalUrl;
    private readonly basePath = 'trazabilidad/services/generarTrazabilidad/';

    constructor(private readonly http: HttpClient) { }

    private post(endpoint: string, body: NeoTrazabilidadAuditoriaDTO): Observable<any> {
        return this.http
            .post(`${this.url}${this.basePath}${endpoint}`, body)
            .pipe(catchError(HandleHttpError));
    }

    revisionSolicitud(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('documentacion', body);
    }

    generarCreacionOferta(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('creacionOferta', body);
    }

    generarRevisionNegacion(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('revisionNegacion', body);
    }

    generarDevolucionOferta(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('devolucionOferta', body);
    }

    generarCorreccionAprobacionOferta(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('correccionAprobacionOferta', body);
    }

    generarCorreccionNegacionOferta(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('correccionNegacionOferta', body);
    }

    generarAprobacionOferta(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('aprobacionOferta', body);
    }

    generarRechazoOferta(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('rechazoOferta', body);
    }

    generarAprobacionDesembolso(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('aprobacionDesembolso', body);
    }

    generarNegacionDesembolso(body: NeoTrazabilidadAuditoriaDTO) {
        return this.post('negacionDesembolso', body);
    }

    cierreTrazabilidad(idTrazabilidad: number): Observable<any> {
        const endpoint = `trazabilidad/services/cierreTrazabilidad/${idTrazabilidad}`;
        return this.http
            .get(`${this.url}${endpoint}`)
            .pipe(catchError(HandleHttpError));
    }
}